<script lang="ts">
  import { onMount } from "svelte";
  import { navigate } from "../../app.logic";
  import PortalUserDropdown from "../../components/Business/PortalUserDropdown.svelte";
  // import UserTimeStats from "../../components/Business/UserTimeStats.svelte";
  import CustomFields from "../../components/CustomFields/CustomFields.svelte";
  import ClfDropdown from "../../components/Form/Fields/Dropdown/ClfDropdown.svelte";
  import SrlDropdown from "../../components/Form/Fields/Dropdown/SrlDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import Textarea from "../../components/Form/Fields/Textarea.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import DateInput from "../../components/Form/Fields/DateInput.svelte";
  import type { IDeal } from "../../entities";
  import FormLayout from "../../layout/FormLayout.svelte";
  import MainLayout from "../../layout/MainLayout.svelte";
  import type { IApiResponse } from "../../utils/api/api-response";
  // import { formatCurrency } from "../../utils/date-utils";
  import {
    addComment,
    comments,
    customFieldsSchemas,
    delComment,
    initDetail,
    record,
    save,
  } from "./deal.store";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import CompanyDropdown from "../../components/Business/CompanyDropdown.svelte";
  import ContactDropdown from "../../components/Business/ContactDropdown.svelte";
  import ProductDropdown from "../../components/Business/ProductDropdown.svelte";
  import CommentListEditor from "../../components/Business/CommentListEditor.svelte";

  export let oid: number;

  $: isNew = oid == 0;
  $: canSubmit =
    $record != null &&
    $record.name != "" &&
    $record.companyId != null &&
    (isNew || $record.srlDealStageId != null);

  async function onSubmit() {
    let newP = isNew;
    let _resp: IApiResponse<IDeal> = await save();
    let u = _resp.payload;
    if (newP) {
      oid = u.oid;
      record.set(u);
      navigate(`/deal/${u.oid}`);
    } else {
      onCancel();
    }
  }

  function onCancel() {
    navigate(`/deal`);
  }

  onMount(() => initDetail(oid));
</script>

<MainLayout>
  {#if $record}
    <div class="columns">
      <div class="column is-9">
        <FormLayout
          {canSubmit}
          {isNew}
          on:submit={onSubmit}
          on:cancel={onCancel}
        >
          <div class="columns">
            <div class="column is-8">
              <FormField>
                <Input
                  name="Nome"
                  placeholder="Nome"
                  required={true}
                  bind:value={$record.name}
                />
              </FormField>
            </div>

            {#if !isNew}
              <div class="column is-4">
                <FormField>
                  <SrlDropdown
                    name="Stato Deal"
                    schema="DEALSTAGEX"
                    required={true}
                    clearVisible={false}
                    bind:value={$record.srlDealStageId}
                  />
                </FormField>
              </div>
            {/if}
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <CompanyDropdown
                  name="Organizzazione"
                  required={true}
                  clearVisible={false}
                  bind:value={$record.companyId}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <ContactDropdown
                  name="Contatto"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.contactId}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <ClfDropdown
                  name="Tipologia"
                  schema="DEALTYPEXX"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.clfDealTypeId}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <ClfDropdown
                  name="Priorità"
                  schema="DEALPRIORT"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.clfDealPriorityId}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <ClfDropdown
                  name="Sorgente"
                  schema="SOURCETYPS"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.clfSourceId}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <ClfDropdown
                  name="Canale"
                  schema="DEALCHANNL"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.clfDealChannelId}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <DateInput
                  name="Data Inizio"
                  placeholder="inizio"
                  required={false}
                  bind:value={$record.startDate}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <DateInput
                  name="Data Fine"
                  placeholder="fine"
                  required={false}
                  bind:value={$record.endDate}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <NumberInput
                  name="Probabilità"
                  required={false}
                  bind:value={$record.probability}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <NumberInput
                  name="Valore"
                  required={false}
                  bind:value={$record.value}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <PortalUserDropdown
                  name="Responsabile"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.responsibleUserId}
                />
              </FormField>
            </div>

            <div class="column">
              <FormField>
                <ProductDropdown
                  name="Prodotto"
                  required={false}
                  clearVisible={true}
                  bind:value={$record.productId}
                />
              </FormField>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <FormField>
                <Textarea
                  name="Note"
                  placeholder="note"
                  required={false}
                  bind:value={$record.notes}
                />
              </FormField>
            </div>
          </div>

          <CustomFields
            schemas={$customFieldsSchemas}
            bind:values={$record.customFields}
          />
        </FormLayout>
      </div>
      <div class="column is-3">
        <!--
        <div class="box">
          <h1 class="subtitle">Riepilogo</h1>
        </div>
      -->

        <CommentListEditor
          entityId={$record.oid}
          comments={$comments}
          disabled={isNew}
          on:save={addComment}
          on:delete={delComment}
        />
      </div>
    </div>
  {/if}
</MainLayout>
